/**
 * Smart API URL resolver
 * 
 * Handles the case where REACT_APP_BACKEND_URL might point to a different domain
 * than where the app is actually running (e.g., preview URL baked into production build).
 * 
 * Falls back to relative URLs (same-origin) when a cross-domain mismatch is detected,
 * avoiding CORS issues in production.
 */
export function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';

  // In browser context, check if env URL matches current origin
  if (typeof window !== 'undefined' && envUrl) {
    try {
      const envOrigin = new URL(envUrl).origin;
      const currentOrigin = window.location.origin;
      if (envOrigin !== currentOrigin) {
        // Env URL points to a different domain (e.g., preview URL on production)
        // Use relative URLs to stay on the same origin — avoids CORS
        console.log(`[API] Domain mismatch detected: env=${envOrigin}, current=${currentOrigin}. Using relative URLs.`);
        return '';
      }
    } catch {
      // Invalid URL format, fall through to use envUrl as-is
    }
  }

  return envUrl;
}

// Export a singleton value for consistent usage across the app
const API_BASE_URL = getApiBaseUrl();
export default API_BASE_URL;
